import { queryOptions } from "@tanstack/react-query";
import { listDeveloperApps, listDeveloperMedia } from "./apps.api";

export const appsQuery = (enabled = true) =>
  queryOptions({
    queryKey: ["developer-apps"],
    queryFn: listDeveloperApps,
    enabled,
  });

export const mediaQuery = (packageName: string, enabled = true) =>
  queryOptions({
    queryKey: ["developer-media", packageName],
    queryFn: () => listDeveloperMedia(packageName),
    enabled,
  });
